import React, { useState, useEffect } from 'react';
import { Coffee, Users, FileText, Wallet, Receipt, TrendingUp, Coins, Database, Activity, LayoutDashboard } from 'lucide-react';
import ResumenDireccion from './ResumenDireccion';
import ClientesMaquinas from './ClientesMaquinas';
import EstadoPagos from './EstadoPagos';
import CotizacionesPuntoV from './CotizacionesPuntoV';
import SolicitudesFactura from './SolicitudesFactura';
import VentasPuntoV from './VentasPuntoV';
import MonitorVentas from './MonitorVentas';
import CobroClientes from './CobroClientes';
import DiagnosticoBases from './DiagnosticoBases';
import { puntovService } from '../../../services/api';

// Pestañas del módulo. Las que aún no tienen backend quedan visibles pero
// deshabilitadas, para que el alcance del módulo se lea desde la UI.
const TABS = [
  { id: 'resumen', label: 'Resumen', icon: LayoutDashboard, disponible: true },
  { id: 'clientes', label: 'Clientes y máquinas', icon: Users, disponible: true },
  { id: 'monitor', label: 'Monitor', icon: Activity, disponible: true },
  { id: 'ventas', label: 'Ventas', icon: TrendingUp, disponible: true },
  { id: 'pagos', label: 'Estado de pagos', icon: Wallet, disponible: true },
  { id: 'cobro', label: 'Cobro y cortesías', icon: Coins, disponible: true },
  { id: 'cotizaciones', label: 'Cotizaciones', icon: FileText, disponible: true },
  { id: 'facturas', label: 'Solicitudes de factura', icon: Receipt, disponible: true },
  { id: 'bases', label: 'Bases', icon: Database, disponible: true }
];

const PuntoVView = () => {
  const [activeTab, setActiveTab] = useState('resumen');
  const [facturasPorAtender, setFacturasPorAtender] = useState({ total: 0, vencidas: 0 });

  // Contador en la pestaña para que una factura por vencer se vea desde
  // cualquier pestaña del módulo.
  useEffect(() => {
    puntovService.listarSolicitudesFactura()
      .then(res => {
        const abiertas = (res.data || []).filter(s => s.situacion !== 'enviada');
        setFacturasPorAtender({ total: abiertas.length, vencidas: abiertas.filter(s => s.situacion === 'vencida').length });
      })
      .catch(() => {});
  }, [activeTab]);

  return (
    <div className="p-2 md:p-6 space-y-6">
      <div>
        <h2 className="text-xl lg:text-2xl font-bold text-gray-800 flex items-center gap-2">
          <Coffee className="text-blue-600" />
          Punto V
        </h2>
        <p className="text-sm lg:text-base text-gray-600">
          Clientes, máquinas y cobros de Punto V Manager.
        </p>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => t.disponible && setActiveTab(t.id)}
              disabled={!t.disponible}
              title={t.disponible ? undefined : 'Próximamente'}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2 ${
                activeTab === t.id
                  ? 'border-blue-500 text-blue-600'
                  : t.disponible
                    ? 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    : 'border-transparent text-gray-300 cursor-not-allowed'
              }`}
            >
              <t.icon size={16} />
              {t.label}
              {t.id === 'facturas' && facturasPorAtender.total > 0 && (
                <span
                  title={facturasPorAtender.vencidas ? `${facturasPorAtender.vencidas} vencida(s)` : 'Por enviar'}
                  className={`min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] font-semibold flex items-center justify-center text-white ${
                    facturasPorAtender.vencidas ? 'bg-red-600' : 'bg-amber-500'
                  }`}
                >
                  {facturasPorAtender.total}
                </span>
              )}
              {!t.disponible && (
                <span className="text-[10px] uppercase tracking-wide bg-gray-100 text-gray-400 rounded px-1.5 py-0.5">
                  Próximamente
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'resumen' && <ResumenDireccion onIr={setActiveTab} />}
      {activeTab === 'clientes' && <ClientesMaquinas />}
      {activeTab === 'monitor' && <MonitorVentas />}
      {activeTab === 'ventas' && <VentasPuntoV />}
      {activeTab === 'pagos' && <EstadoPagos />}
      {activeTab === 'cobro' && <CobroClientes />}
      {activeTab === 'cotizaciones' && <CotizacionesPuntoV />}
      {activeTab === 'facturas' && <SolicitudesFactura />}
      {activeTab === 'bases' && <DiagnosticoBases />}
    </div>
  );
};

export default PuntoVView;
